import { PeekInput, PeekPhoneInput } from "@piiqtechnologies/ui-components";
import { useIntl } from "react-intl";
import * as yup from "yup";
import messages from "./messages.i18n";
export const CreateProspectFormValidationSchema = yup.object({
    firstName: yup
        .string()
        .trim()
        .min(2, "First name should have at least 2 characters")
        .required("First name is required"),
    lastName: yup.string().trim().min(2, "Last name should have at least 2 characters").required("Last name is required"),
    phone: yup
        .string()
        .trim()
        .min(12, "Hm... that phone number doesn’t look right!")
        .required("Phone number is required"),
    email: yup.string().trim().email("Hm... that email doesn’t look right!").required("Email address is required"),
});
export const CreateProspectFormInitialValues = {
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
};
export const getCreateProspectFormFields = () => {
    const intl = useIntl();
    return {
        personal: [
            {
                id: "firstName",
                label: intl.formatMessage(messages.createProspectFormFirstName),
                placeholder: intl.formatMessage(messages.createProspectFormFirstName),
                required: true,
                component: PeekInput,
                fullWidth: true,
                columns: 12,
            },
            {
                id: "lastName",
                label: intl.formatMessage(messages.createProspectFormLastName),
                placeholder: intl.formatMessage(messages.createProspectFormLastName),
                required: true,
                component: PeekInput,
                fullWidth: true,
                columns: 12,
            },
        ],
        email: [
            {
                id: "email",
                label: intl.formatMessage(messages.createProspectFormEmail),
                placeholder: intl.formatMessage(messages.createProspectFormEmail),
                required: true,
                component: PeekInput,
                fullWidth: true,
                columns: 12,
            },
        ],
        phone: [
            {
                id: "phone",
                label: intl.formatMessage(messages.createProspectFormPhoneNumber),
                placeholder: "XXX-XXX-XXXX",
                required: true,
                component: PeekPhoneInput,
                fullWidth: true,
                columns: 12,
            },
        ],
    };
};
